import * as React from "react"
import {SingleDatePicker} from "react-dates"
import "react-dates/lib/css/_datepicker.css"
import * as moment from "moment"
import {Form, Loader, Popup} from "semantic-ui-react"
import TimePicker from "rc-time-picker"
import {
  bookingDateDisplayFormat,
  bookingDateToDisplayString,
  bookingTimeTooClose,
  bookingTimeToString,
  bookingTooCloseMsg,
  momentBookingDateToBackendString,
} from "../model/time"
import {assertNonNull} from "../tsutil"
import {MapState} from "./BookingDetails"
import {BookingStatusProp, ErrorLabel} from "./AddBookingWizard"

export interface ScheduleState {
  bookingDate: string
  bookingHour: number
  bookingMinute: number
  editingDate: boolean
}

interface Props extends BookingStatusProp {
  state: ScheduleState
  mapState: MapState<ScheduleState> | null
  disabled: boolean
  isAdmin: boolean
}

interface State {}

const bookingTimeMessage =
  "To avoid confusion you cannot book at midnight. Please use 11:55pm or 12:05am instead."

export class ScheduleFields extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  render() {
    const calendarFromDate = moment().add(-2, "days")
    const {mapState, disabled, bookingStatus, bookingStatusLoading, isAdmin} = this.props
    const {bookingDate, editingDate} = this.props.state

    const bookingDateString = bookingDateToDisplayString(bookingDate)
    const error =
      bookingStatus && mapState && !isAdmin && bookingTimeTooClose(bookingStatus, moment())
        ? bookingTooCloseMsg
        : null

    return (
      <>
        <Form.Group>
          <Form.Field error={error !== null}>
            <label>Booking date</label>
            {mapState ? (
              disabled && !editingDate ? (
                <Form.Input disabled={true} readOnly value={bookingDateString} />
              ) : (
                <SingleDatePicker
                  id="1"
                  date={bookingMoment(this.props.state)}
                  isOutsideRange={(day: moment.Moment) => {
                    return day.isBefore(calendarFromDate)
                  }}
                  onDateChange={(date: moment.Moment | null) => {
                    mapState((state) => ({
                      ...state,
                      bookingDate: momentBookingDateToBackendString(assertNonNull(date)),
                    }))
                  }}
                  readOnly
                  focused={editingDate}
                  numberOfMonths={1}
                  withPortal={false}
                  onFocusChange={({focused}) => {
                    mapState((state) => ({...state, editingDate: focused || false}))
                  }}
                  hideKeyboardShortcutsPanel
                  displayFormat={bookingDateDisplayFormat}
                />
              )
            ) : (
              <div>{bookingDateString}</div>
            )}
          </Form.Field>
          <TimeField
            error={error}
            state={this.props.state}
            disabled={disabled}
            mapState={mapState}
          />
          {bookingStatusLoading ? <Loader active inline size="tiny" /> : null}
        </Form.Group>
      </>
    )
  }
}

function bookingMoment(state: ScheduleState) {
  const {bookingDate, bookingHour, bookingMinute} = state
  return moment(bookingDate)
    .hour(bookingHour)
    .minute(bookingMinute)
}

export function TimeField(props: {
  disabled: boolean
  error: string | null
  state: ScheduleState
  mapState: MapState<ScheduleState> | null
}) {
  const {
    mapState,
    error,
    state,
    state: {bookingHour, bookingMinute},
    disabled,
  } = props
  return (
    <Form.Field error={error !== null}>
      <Popup trigger={<label>Booking time</label>} content={bookingTimeMessage} wide />
      {mapState ? (
        <TimePicker
          inputReadOnly={true}
          style={{width: 100}}
          disabled={disabled}
          allowEmpty={false}
          use12Hours={true}
          showSecond={false}
          value={bookingMoment(state)}
          minuteStep={5}
          format="h:mm a"
          onChange={(time: moment.Moment) => {
            const hour = time.hour()
            const minute = time.minute()
            mapState((state) => ({
              ...state,
              bookingHour: hour,
              bookingMinute: hour === 0 && minute === 0 ? 5 : minute,
            }))
          }}
        />
      ) : (
        <div>{bookingTimeToString(bookingHour, bookingMinute)}</div>
      )}
      <ErrorLabel error={error} />
    </Form.Field>
  )
}



// WEBPACK FOOTER //
// ./src/components/ScheduleFields.tsx